import { postAwardStages } from '../../constants/workflowStages';
import type { HomeChatPageContext } from './types';

/**
 * Builds the only companion context allowed for a Post-award workflow page.
 * Workspace data stays out of this display-only model grounding.
 */
export function getPostAwardWorkflowChatPageContext(
  currentStage: number,
  flowName?: string,
): HomeChatPageContext | undefined {
  const stage = postAwardStages[currentStage];
  if (!stage) return undefined;
  return {
    workflowType: 'post_award_actions',
    workflowLabel: 'Post-award Actions',
    ...(flowName ? { workflowName: flowName } : {}),
    stageName: stage.name,
    ...(stage.description ? { stageDescription: stage.description } : {}),
  };
}


/** Browser identity selects a server-authorized record; it contains no facts. */
export function getMarketResearchWorkflowChatPageContext(
  stage: { name: string; description: string; backendCode: number } | undefined,
  flowId?: string | null,
  flowName?: string,
): HomeChatPageContext | undefined {
  if (!stage) return undefined;
  return {
    workflowType: 'market_research',
    workflowLabel: 'Market Research',
    ...(flowName ? { workflowName: flowName } : {}),
    stageName: stage.name,
    ...(stage.description ? { stageDescription: stage.description } : {}),
    ...(flowId ? { flowId, stageNumber: stage.backendCode } : {}),
  };
}
